import { render, staticRenderFns } from "./SelfSkillTopic.vue?vue&type=template&id=b14283d0&"
import script from "./SelfSkillTopic.vue?vue&type=script&lang=js&"
export * from "./SelfSkillTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports